<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-12 mb-2" v-if="Object.keys(legalCustomerDetails).length">
                    <h5>اطلاعات سازمان</h5>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover user-details-table">
                            <tbody>
                                    <tr>
                                        <td>نام فارسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameFa }}</td>
                                        <td>نام انگلیسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameEn }}</td>
                                        <td>شناسه ملی:</td>
                                        <td>{{ legalCustomerDetails.nationalId }}</td>
                                    </tr>
                                </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-4">
                            <form class="form-group" v-on:submit.prevent="findCardData">
                                <label>شماره کارت</label>
                                <div class="input-group">
                                    <input type="tel" class="form-control text-center" v-mask="'####-####-####-####'" v-model="pan" dir="ltr" style="direction: ltr !important">
                                    <span class="input-group-btn" v-if="pan && pan.replace(/-/g,'').length == 16"><button class="btn ripple btn-info" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                                </div>
                            </form>
                        </div>
                        <div class="col-md-12 mb-3" v-if="Object.keys(cardData).length">
                            <hr>
                        </div>
                        <div class="col-md-12" v-if="Object.keys(cardData).length">
                            <table class="table table-bordered table-hover user-details-table">
                                <tbody>
                                    <tr>
                                        <td>نام و نام خانوادگی صاحب کارت:</td>
                                        <td>{{ cardData.firstName + ' ' + cardData.lastName }}</td>
                                        <td>کد ملی:</td>
                                        <td>{{ cardData.nationalCode }}</td>
                                        <td>شماره همراه:</td>
                                        <td>{{ cardData.mobileNo }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div  class="col-md-3" v-if="Object.keys(cardData).length && !session && $store.state.role != 'jahesh'">
                            <div class="form-group">
                                <label>نوع درخواست</label>
                                <select class="form-control" :class="!requestType ? 'is-invalid' : ''" v-model="requestType">
                                    <option selected disabled value="">انتخاب کنید</option>
                                    <option value="1">مسدودی</option>
                                    <option value="2">رفع مسدودی</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-9" v-if="Object.keys(cardData).length && !session">
                            <div class="form-group">
                                <label>توضیحات</label>
                                <input type="text" class="form-control" :class="!description ? 'is-invalid' : ''" v-model="description">
                            </div>
                        </div>
                        <div class="col-md-3" v-if="Object.keys(cardData).length && session">
                            <div class="form-group">
                                <label>کد اعتبارسنجی</label>
                                <input type="tel" class="form-control ltr-input" v-mask="'#####'" v-model="otp">
                            </div>
                        </div>
                        <div class="col-md-9" style="margin-top:28px" v-if="Object.keys(cardData).length && $store.state.role != 'jahesh'">
                            <button class="btn btn-success" @click="submit">ثبت درخواست</button>
                        </div>
                         <div class="col-md-9" style="margin-top:28px" v-if="Object.keys(cardData).length && $store.state.role == 'jahesh'">
                            <button :class="'btn ' + (!this.requestType ? 'btn-success' : 'btn-danger')" @click="submit"> {{ !this.requestType ? "رفع مسدودی کارت ":"مسدود سازی کارت" }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="false">
                <div class="col-md-3">
                    <form v-on:submit.prevent="searchCustomer">
                        <label for="national-code">شناسه ملی</label>
                        <div class="input-group">
                            <input class="form-control text-left" maxlength="11" id="national-code" type="tel" v-model="nationalCode">
                            <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlockUnBlock',
    data(){
        return {
            resultFile: '',
            cardData: {},
            showLoading: false,
            nationalCode: '',
            description: '',
            legalCustomerDetails: {},
            requestType: '',
            pan: '505785',
            otp: '',
            session: '',
            customerId: 0
        }
    },
    methods: {
        searchCustomer(){
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status){
                    this.legalCustomerDetails = data.result;
                    this.customerId = data.result.customerId;
                }
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        findCardData(){
            this.showLoading = true;
            this.$api.get('Cards/GetCardInfo?pan=' + this.pan.toString().replace(/-/g,'')).then(({data}) => {
                if(data.status){
                    this.cardData = data.result;
                }
                if(this.$store.state.role == 'jahesh'){
                    this.requestType =data.result.status;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        submit(){
            this.showLoading = true;
            
            if(this.requestType == 1){
                const postedData = {
                    pan: this.pan.toString().replace(/-/g,''),
                    description: this.description
                };
                this.$api.post('Cards/deActivateCard',postedData).then(({data}) => {
                    if(data.status){
                        this.$swal({
                            title: 'تبریک',
                            icon: 'success',
                            text: 'کارت مورد نظر با موفقیت مسدود شد',
                            confirmButtonText: 'متوجه شدم'
                        });
                        this.session = '';
                        this.otp = '';
                        this.description = '';
                        this.pan = '505785',
                        this.nationalCode = '';
                        this.cardData = {};
                        this.requestType = '';
                        this.legalCustomerDetails = {};
                        this.customerId = 0;
                    }
                }).finally(() => {
                    this.showLoading = false;
                });
            }else{
                // if(this.session == ''){
                //     const postedData = {
                //         pan: this.pan.toString().replace(/-/g,'')
                //     };
                //     this.$api.post('Pin/GenerateCardPinOTP',postedData).then(({data}) => {
                //         if(data.status)
                //             this.session = data.result.session
                //     }).finally(() => {
                //         this.showLoading = false;
                //     });
                // }else{
                    const postedData = {
                        pan: this.pan.toString().replace(/-/g,''),
                        description: this.description
                    };
                    this.$api.post('Cards/ActivateCard',postedData).then(({data}) => {
                        if(data.status){
                            this.$swal({
                                title: 'تبریک',
                                icon: 'success',
                                text: 'رفع مسدودی کارت مورد نظر با موفقیت انجام شد',
                                confirmButtonText: 'متوجه شدم'
                            });
                            this.session = '';
                            this.otp = '';
                            this.pan = '505785',
                            this.nationalCode = '';
                            this.cardData = {};
                            this.requestType = '';
                            this.legalCustomerDetails = {};
                            this.customerId = 0;
                        }
                    }).finally(() => {
                        this.showLoading = false;
                    });
                // }
            }
        }
    }
}
</script>
<style>
.is-invalid{
    border-color: red !important;
}
</style>